<div class="progress">
    <div class="progress-bar progress-bar-striped active">
        {{"LOADING"|translate}}
    </div>
</div>